import { useEffect } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { enableFabricEmbedMode, isFabricEmbedMode } from '@/lib/fabricEmbedAuth'
import DatasheetPreview from '@/components/DatasheetPreview'

/**
 * Embed-friendly route for viewing timeseries data in a Fabric iframe.
 * Auth is handled via PostMessage token exchange (not Keycloak).
 * Renders DatasheetPreview — a virtualized spreadsheet with pagination and zoom.
 *
 * Security: This route is embedded from the DataCatalog item's DocumentDetailView,
 * which sends AUTH_TOKEN via PostMessage. API-level auth (the exchanged token)
 * protects data access.
 */
export default function TimeseriesEmbedView() {
  const { doc_id } = useParams<{ doc_id: string }>()
  const [searchParams] = useSearchParams()

  // Fabric embed mode: detect from URL query parameter
  const isEmbedMode = searchParams.get('embed') === 'fabric'
  useEffect(() => {
    if (isEmbedMode && !isFabricEmbedMode()) {
      enableFabricEmbedMode()
    }
  }, [isEmbedMode])

  if (!doc_id) {
    return (
      <div className="flex h-full w-full items-center justify-center bg-gray-50 dark:bg-dark-muted">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-800 dark:text-dark-text mb-2">Timeseries Not Found</h2>
          <p className="text-gray-600 dark:text-gray-400">No document ID was provided.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="w-full h-screen overflow-hidden">
      <DatasheetPreview docId={doc_id} />
    </div>
  )
}
